// client/src/components/world/SystemMinimap.jsx
// Итерация 6.4: миникарта звёздной системы (межпланетный перелёт).
// Пока заглушка — ждём system_info от backend (Распоряжение №12, п. 2.5).

import React from 'react';
import { Box, Typography, Alert, Chip } from '@mui/material';
import { Public as StarIcon } from '@mui/icons-material';

export default function SystemMinimap({ locationInfo, characterMeta }) {
  const systemInfo = locationInfo?.system_info;
  const hasData = systemInfo && Array.isArray(systemInfo.planets) && systemInfo.planets.length > 0;

  return (
    <Box
      sx={{
        p: 1,
        borderRadius: 1.5,
        bgcolor: 'rgba(255,255,255,0.03)',
        border: '1px solid rgba(255,255,255,0.05)',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
        <StarIcon sx={{ color: '#ffb74d', fontSize: 14 }} />
        <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.6rem', flex: 1 }}>
          ⭐ Звёздная система
        </Typography>
        {systemInfo?.name && (
          <Chip
            label={systemInfo.name}
            size="small"
            sx={{ height: 14, '& .MuiChip-label': { fontSize: '0.4rem', px: 0.5 } }}
          />
        )}
      </Box>

      {!hasData && (
        <Alert severity="info" sx={{ py: 0, fontSize: '0.55rem' }}>
          Данные о системе ещё не поступают с сервера (Итерация 6.6)
        </Alert>
      )}

      {hasData && (
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            aspectRatio: '1 / 1',
            maxHeight: 200,
            bgcolor: 'rgba(0,0,0,0.3)',
            borderRadius: 1,
            border: '1px solid rgba(255,255,255,0.05)',
          }}
        >
          <Typography
            variant="caption"
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: '0.5rem',
              color: 'text.secondary',
            }}
          >
            Миникарта системы ({systemInfo.planets.length} планет)
          </Typography>
        </Box>
      )}
    </Box>
  );
}
